module.exports = __webpack_public_path__ + "img/ROROCCCO01390548.4d657334.png";